import { flow } from 'lodash';
import { startOfMonth, addWeeks, setDay, getDay, setHours } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const tuesday = 2;

/**
 * Get the second tuesday in the current month
 */

export const getSecondTuesday = (m: Date): Date =>
  flow(
    (item: Date) => new Date(item.toUTCString()),
    item =>
      utcToZonedTime(item, 'America/Los_Angeles', {
        timeZone: 'America/Los_Angeles',
      }),
    startOfMonth,
    // Use the first day of the month as the starting day
    // of the week, then pick tuesday
    item => setDay(item, tuesday, { weekStartsOn: getDay(item) }),
    item => addWeeks(item, 1),
    item => setHours(item, 10),
    item => zonedTimeToUtc(item, 'America/Los_Angeles')
  )(m);
